import React, {useState} from 'react';
import {Map, GoogleApiWrapper, Marker} from 'google-maps-react';
import mapStyles from '../mapstyle';
import config from '../config';

const MapComponent = (props) => {
    const [zoomLevel, setZoomLevel] = useState(config.zoomLevel)
    const [lat, setLat] = useState(config.lat || 29.628154);
    const [lng, setLng] = useState(config.lng || 52.526928);


    return (
        <div className='map'>
            <Map
                google={props.google}
                zoom={zoomLevel}
                styles={mapStyles}
                disableDefaultUI={config.useDefaultUI}
                initialCenter={{
                    lat,
                    lng
                }}
            >
                <Marker
                    position={{lat: config.latitudeForMarker, lng: config.longitudeForMarker}}
                    icon={config.googleMapsMarkerIcon}
                   /* icon={{
                        url: "./imgs/marker.png",
                        anchor: new window.google.maps.Point(10, 10),
                        scaledSize: new window.google.maps.Size(20, 20)
                    }}*/
                />
            </Map>
        </div>
    );
};

export default GoogleApiWrapper({apiKey: config.apiKey})(MapComponent);